/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateRecordingScheduleRequest } from '../model/createRecordingScheduleRequest';
import { ManagementRecordingScheduleResponse } from '../model/managementRecordingScheduleResponse';
import { ManagementRecordingScheduleWithMediumResponse } from '../model/managementRecordingScheduleWithMediumResponse';
import { SaveRecordingScheduleResponse } from '../model/saveRecordingScheduleResponse';
import { UpdateRecordingScheduleRequest } from '../model/updateRecordingScheduleRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ManagementRecordingScheduleControllerService {

    protected basePath = 'https://clipping.sette-services.inellipse.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     *
     *
     * @param mediumId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSchedule(mediumId: string, body: CreateRecordingScheduleRequest, observe?: 'body', reportProgress?: boolean): Observable<SaveRecordingScheduleResponse>;
    public createSchedule(mediumId: string, body: CreateRecordingScheduleRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveRecordingScheduleResponse>>;
    public createSchedule(mediumId: string, body: CreateRecordingScheduleRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveRecordingScheduleResponse>>;
    public createSchedule(mediumId: string, body: CreateRecordingScheduleRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mediumId === null || mediumId === undefined) {
            throw new Error('Required parameter mediumId was null or undefined when calling createSchedule.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createSchedule.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SaveRecordingScheduleResponse>('post',`${this.basePath}/v1/management/mediums/${encodeURIComponent(String(mediumId))}/recording-schedules`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Every schedule, every medium - backs the Gantt chart screen.
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSchedules(observe?: 'body', reportProgress?: boolean): Observable<Array<ManagementRecordingScheduleWithMediumResponse>>;
    public getAllSchedules(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ManagementRecordingScheduleWithMediumResponse>>>;
    public getAllSchedules(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ManagementRecordingScheduleWithMediumResponse>>>;
    public getAllSchedules(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ManagementRecordingScheduleWithMediumResponse>>('get',`${this.basePath}/v1/management/recording-schedules`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSchedule(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSchedule(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSchedule(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSchedule(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteSchedule.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/management/recording-schedules/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param mediumId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSchedulesForMedium(mediumId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ManagementRecordingScheduleResponse>>;
    public getSchedulesForMedium(mediumId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ManagementRecordingScheduleResponse>>>;
    public getSchedulesForMedium(mediumId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ManagementRecordingScheduleResponse>>>;
    public getSchedulesForMedium(mediumId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mediumId === null || mediumId === undefined) {
            throw new Error('Required parameter mediumId was null or undefined when calling getSchedulesForMedium.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ManagementRecordingScheduleResponse>>('get',`${this.basePath}/v1/management/mediums/${encodeURIComponent(String(mediumId))}/recording-schedules`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSchedule(id: string, body: UpdateRecordingScheduleRequest, observe?: 'body', reportProgress?: boolean): Observable<SaveRecordingScheduleResponse>;
    public updateSchedule(id: string, body: UpdateRecordingScheduleRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveRecordingScheduleResponse>>;
    public updateSchedule(id: string, body: UpdateRecordingScheduleRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveRecordingScheduleResponse>>;
    public updateSchedule(id: string, body: UpdateRecordingScheduleRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateSchedule.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateSchedule.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SaveRecordingScheduleResponse>('put',`${this.basePath}/v1/management/recording-schedules/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
